module.exports = __webpack_public_path__ + "media/精工工艺--防盗门.feff145c.mp4";